/* Feedback endpoint. Old call site: the "Send feedback" modal
 * (service/review/index.html ~3492-3494) — POSTs straight to /feedback,
 * no memoization or GET (the frontend never calls GET /feedback; that
 * route exists on the backend for other consumers only).
 */
import { request } from './client.ts';

/** A pinned-feedback capture (W3-I). Additive to the feedback record: the
 * server's FeedbackIn.pin is optional, so a plain (non-pin) feedback POST omits
 * it entirely and behaves exactly as before. Mirrors service FeedbackPin. */
export interface FeedbackPin {
  /** the route the pin was taken on (location.hash, e.g. "#/client/el-al"). */
  route: string;
  /** a stable CSS selector re-finding the clicked element. */
  selector: string;
  /** true when the selector is id-anchored (exact); false = best-effort path. */
  exact: boolean;
  /** trimmed text label of the element (human-readable retrieval). */
  elementText: string;
  /** the clicked element's tag name. */
  tag: string;
  /** click point in viewport CSS px. */
  x: number;
  y: number;
  /** click position 0..1 within the element (layout-shift-resilient). */
  relX: number;
  relY: number;
  /** the element's bounding rect at capture. */
  rect: { x: number; y: number; w: number; h: number };
  /** the viewport size at capture. */
  viewport: { w: number; h: number };
  /** the build the pin was taken against (lib/version.ts BUILD_VERSION). */
  build: string;
}

export interface FeedbackPayload {
  section: string;
  comment: string;
  author: string;
  brand: string | null;
  page: string;
  /** present only for a pinned-feedback capture (W3-I). */
  pin?: FeedbackPin;
}

export function postFeedback(payload: FeedbackPayload): Promise<unknown> {
  return request('/feedback', {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}
